import regrasDeCalculo from './RegrasDeCalculo/index'

export default {
  calcs: regrasDeCalculo
}
